const API_URL = process.env.VUE_APP_API_URL
const getToken = () => localStorage.getItem('access-token')

export default {
  async getPromotionsAPI (page = 1, search = '') {
    const response = await fetch(`${API_URL}/admin/promotions?page=${page}&search=${search}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })

    let resp = await response.json()
    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async getGroupUsersListAPI () {
    const response = await fetch(`${API_URL}/admin/promotions/group-users`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    let resp = await response.json()

    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async createdPromotionAPI (data) {
    const response = await fetch(`${API_URL}/admin/promotions/new-promotion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('access-token')
      },
      body: JSON.stringify(data)
    })

    let resp = await response.json()
    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        return Promise.reject(new Error(resp.error))
      }
    }
    return resp
  },
  async deletedPromotionAPI (promotionId) {
    const response = await fetch(`${API_URL}/admin/promotions/del-promotion/${promotionId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('access-token')
      }
    })

    let resp = await response.json()
    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        return Promise.reject(new Error(resp.error))
      }
    }
    return resp
  },
  async editedPrmoAPI (data, promotionId) {
    const response = await fetch(`${API_URL}/admin/promotions/edit-promotion/${promotionId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify(data)
    })

    let resp = await response.json()

    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async promoDetailAPI (promotionId) {
    const response = await fetch(`${API_URL}/admin/promotions/${promotionId}/detail`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    let resp = await response.json()

    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async createdReferralAPI (data) {
    const response = await fetch(`${API_URL}/admin/promotions/referral/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('access-token')
      },
      body: JSON.stringify(data)
    })

    let resp = await response.json()
    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        return Promise.reject(new Error(resp.error))
      }
    }
    return resp
  },
  async getAmountRefferalAPI () {
    const response = await fetch(`${API_URL}/admin/promotions/referral`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    let resp = await response.json()

    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async promoCodeDetailAPI (promoCodeId) {
    const response = await fetch(`${API_URL}/v5/admin/promotion-code/${promoCodeId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    let resp = await response.json()
    if (!response.ok) {
      this.isLoading = false
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async promoCodeListAPI (page = 1, search = '') {
    const response = await fetch(`${API_URL}/v5/admin/promotion-code/list?page=${page}&search=${search}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    let resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async createPromoCodeAPI (data) {
    const response = await fetch(`${API_URL}/v5/admin/promotion-code/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify(data)
    })
    let resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async updatePromoCodeAPI (id, data) {
    const response = await fetch(`${API_URL}/v5/admin/promotion-code/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify(data)
    })
    let resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async uploadPartnerLogoAPI (file) {
    const formData = new FormData()
    formData.append('logo', file)
    const response = await fetch(`${API_URL}/v5/admin/partner/logo/upload`, {
      method: 'POST',
      headers: { 'Authorization': getToken() },
      body: formData
    })
    const resp = await response.json()
    if (!response.ok) throw new Error(resp.error || 'Error al subir la imagen.')
    return resp
  },
  async deletePromoCodeAPI (id) {
    const response = await fetch(`${API_URL}/v5/admin/promotion-code/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    let resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  }
}
